<template>
  <v-flex xs12 row>

    <v-layout py-3>
   		<v-flex xs12 sm8 offset-sm2>
   			<v-card>
	   			<v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4 px-3 elevation-1">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Module' : 'Add Module'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field :rules="rules" :readonly="!!item.id" counter="50" v-model="item.module" label="Module"></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field :rules="rules" counter="50" v-model="item.label" label="Label"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" :disabled="processing" flat @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
			    </v-card-title>
	   			<v-data-table :headers="headers" :loading="processing" :items="modules" item-key="id" :search="search" hide-actions disable-initial-sort>
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.module }}</td>
				      <td>{{ props.item.label }}</td>
				      <td class="pt-3"><v-switch :key="props.item.id" v-model="props.item.is_active" v-on:change="update(props.item)" :disabled="!props.item.is_editable"></v-switch></td>
              <td class="align-center justify-center layout px-0">
                <v-icon small class="mr-1" @click="editItem(props.item)" v-if="hasEditAccess && props.item.is_editable">edit</v-icon>
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !modules.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>
			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'ModulesView',
    data () {
      return {
      	title: "Modules",
        validForm: false,
      	processing: false,
        dialog: false,
      	modules: [],
        headers: [
          { text: 'Module', value: 'module'},
          { text: 'Label', value: 'label'},
          { text: 'Status', value: 'is_active' },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          module: "",
          label: "",
          is_active: 0,
          is_editable: 1
        },
        rules: [
          v => !!v || 'Module Name is required',
          v => v && v.length >= 5 || 'Must be more than 4 characters',
          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        search: ""
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Modules',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Modules')
    },
    methods: {

      getModules () {
        this.processing = true
        this.axios.get(this.config.apis.viewModules)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.modules = response.data.data
            }
            else{
            	this.modules = []
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },
      updateItem () {
      	this.update(this.item)
      },
      update (item) {
        this.processing = true
        this.axios.put(this.config.apis.updateModule.replace(":id", item.id), item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },
      addItem () {
        this.processing = true
        this.item.module = this.item.module.replace(/\s/g, '').toLowerCase()
        this.axios.post(this.config.apis.addModule, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              this.modules.unshift(new_item)
              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },
      editItem (item) {
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      },

    },

    computed: {

    },

    mounted () {
    	this.getModules()
      this.item = this.extend({}, this.defaultItem)
    }

  }
</script>
